'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n'], ['\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 18px;\n  height: 18px;\n  user-select: none;\n  transform: translate(-50%, -50%);\n  ', '\n'], ['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 18px;\n  height: 18px;\n  user-select: none;\n  transform: translate(-50%, -50%);\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n          width: 24px;\n          height: 24px;\n          z-index: 2;\n        '], ['\n          width: 24px;\n          height: 24px;\n          z-index: 2;\n        ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Avatar = require('../../Avatar/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Avatar = (0, _styledComponents2.default)(_Avatar2.default)(_templateObject);

var Wrapper = _styledComponents2.default.div(_templateObject2, function (_ref) {
  var selected = _ref.selected;
  return !!selected ? (0, _styledComponents.css)(_templateObject3) : '';
});

var Marker = function (_Component) {
  _inherits(Marker, _Component);

  function Marker() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Marker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Marker.__proto__ || Object.getPrototypeOf(Marker)).call.apply(_ref2, [this].concat(args))), _this), _this.color = function () {
      var _this$props = _this.props,
          moving = _this$props.moving,
          selected = _this$props.selected;
      if (selected) return 'black';
      return moving ? 'red' : 'darkGrey';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Marker, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var changedValues = ['moving', 'selected', 'lat', 'lng', 'driver', 'marker'];
      return changedValues.some(function (val) {
        return _this2.props[val] !== nextProps[val];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          marker = _props.marker,
          selected = _props.selected;
      return _react2.default.createElement(Wrapper, {
        selected: selected
      }, _react2.default.createElement(Avatar, {
        size: selected ? 'small' : 'tiny',
        avatar: marker,
        theme: this.color()
      }));
    }
  }]);

  return Marker;
}(_react.Component);

Marker.propTypes = {
  moving: _propTypes2.default.bool,
  marker: _propTypes2.default.string,
  lat: _propTypes2.default.number,
  lng: _propTypes2.default.number,
  selected: _propTypes2.default.bool
};
exports.default = Marker;